module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.rowData.c_title))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('article', [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.c_title))]), _vm._v(" "), _c('div', {
    staticClass: "editor",
    domProps: {
      "innerHTML": _vm._s(_vm.rowData.c_content)
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("最新消息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("最新消息")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "active item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("主要消息")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("活動消息")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2582a0c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsDetail.vue
// module id = 292
// module chunks = 1